import ReactPaginate from 'react-paginate';
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import { Container } from './style'

interface PaginationProps {
  totalPages: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

interface PaginationData {
  selected: number;
}

const Pagination:React.FC<PaginationProps> = ({ totalPages, setPage }) => {
  const handlePageClick = (data: PaginationData) => {
    setPage(data.selected + 1);
  };
  
  return (
    <Container>
      <ReactPaginate
        previousLabel={<AiOutlineLeft />}
        nextLabel={<AiOutlineRight />}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
    </Container>
  )
}

export default Pagination
